module.exports = __webpack_public_path__ + "img/22.066cee13.png";